import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const ScrollToContext = createContext()

/**
 * The scroll to top custom hook.
 */
export const useScrollToTop = () => useContext(ScrollToContext)

/**
 * The ScrollToTopProvider's component.
 */
export const ScrollToTopProvider = props => {
  const { children } = props
  const handleScrollToTop = (hashId, time = 0) => {
    if (!hashId) {
      return window.scrollTo(0, 0)
    }

    setTimeout(() => document.querySelector(hashId)?.scrollIntoView(), time)
  }

  return <ScrollToContext.Provider value={handleScrollToTop}>{children}</ScrollToContext.Provider>
}

ScrollToTopProvider.propTypes = {
  children: PropTypes.node.isRequired
}
